import { render, staticRenderFns } from "./privacy-policy.vue?vue&type=template&id=1b8a9eca&scoped=true&"
import script from "./privacy-policy.vue?vue&type=script&lang=ts&"
export * from "./privacy-policy.vue?vue&type=script&lang=ts&"
import style0 from "./privacy-policy.vue?vue&type=style&index=0&id=1b8a9eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8a9eca",
  null
  
)

export default component.exports